module.exports = __webpack_public_path__ + "media/images/share-08d165d7914f71a17231071ab061b3b4.svg";